var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Actions/check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3043 3.52896C14.5644 3.78909 14.5644 4.21085 14.3043 4.47098L6.97094 11.8043C6.71081 12.0644 6.28905 12.0644 6.02892 11.8043L2.69559 8.47098C2.43546 8.21085 2.43546 7.78909 2.69559 7.52896C2.95572 7.26883 3.37747 7.26883 3.6376 7.52896L6.49993 10.3913L13.3623 3.52896C13.6224 3.26883 14.0441 3.26883 14.3043 3.52896Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.da2ab4f2f21c41bfdba914f06f855dc4.svg";
export { ForwardRef as ReactComponent };